<form
  class="ship-order-form"
  [formGroup]="form"
  (ngSubmit)="onSubmit()"
  novalidate
>
  <p class="ship-order-intro">
    Vas a marcar el pedido <strong>{{ orderCode }}</strong> como enviado. Ingresa el número de
    orden de transporte que te dio Chilexpress: se guarda en el pedido y se le envía por correo
    al cliente con el link de seguimiento. Si registraste todos los bultos en un solo envío en la
    web de Chilexpress, ingresa ese único número. Si generaste un envío por bulto, ingresa un
    número por envío separado por coma.
  </p>

  @if (!isPaid) {
    <p class="ship-order-warning" role="alert">
      El pago de este pedido todavía no está confirmado. Si lo despachas ahora, lo estás
      enviando sin cobrar.
    </p>
  }

  <div class="form-group">
    <label class="form-label is-required" for="tracking-code">Código de seguimiento</label>
    <input
      id="tracking-code"
      type="text"
      class="form-input"
      formControlName="trackingCode"
      placeholder="Ej: 727712345678 o 727712345678, 727712345685"
      autocomplete="off"
    />
    @if (trackingCodeInvalid) {
      <span class="form-error">Ingresa el número de orden de transporte de Chilexpress (solo dígitos, entre 8 y 20). Si son varios envíos, sepáralos por coma (máximo 512 caracteres).</span>
    }
  </div>

  <div class="form-actions">
    <button type="button" class="btn btn-outline" (click)="onCancel()">
      Cancelar
    </button>
    <button type="submit" class="btn btn-primary" [disabled]="form.invalid">
      Confirmar envío
    </button>
  </div>
</form>
